import React, { useState } from 'react';
import '../css/Footer.css';
import logo from "../assets/2look-logo.png";
import { useNavigate } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaYoutube, 
  FaPinterestP 
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6'; // Latest X logo

const Footer = () => {
  // Mobile par kaun sa section open hai, uski state (null matlab sab closed)
  const [openSection, setOpenSection] = useState(null);
  const navigate= useNavigate("");

  const toggleSection = (sectionName) => {
    // Agar screen width 768px ya usse kam hai, tabhi toggle logic chalega
    if (window.innerWidth <= 768) {
      setOpenSection(openSection === sectionName ? null : sectionName);
    }
  };

  return (
    <footer className="b2b-footer">
      {/* TOP ROW: Logo & Social Links */}
      <div className="footer-top-row">
        <div className="footer-brand-area">
          <div className="footer-logo">
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
          </div>
        </div>
        
        <div className="footer-social-links">
          <span>Social Links</span>
          <div className="social-icons-wrapper">
            <a href="#" className="social-icon fb" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="#" className="social-icon twitter-x" aria-label="X (Twitter)">
              <FaXTwitter />
            </a>
            <a href="#" className="social-icon insta" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="#" className="social-icon yt" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="#" className="social-icon pin" aria-label="Pinterest">
              <FaPinterestP />
            </a>
          </div>
        </div>
      </div>

      <hr className="footer-divider" />

      {/* MIDDLE ROW: Links, Newsletter & Government Certification */}
      <div className="footer-middle-grid">
        {/* Col 1 */}
        <div className={`footer-col ${openSection === 'knowUs' ? 'is-open' : ''}`}>
          <h3 onClick={() => toggleSection('knowUs')}>
            Get to Know Us
            <span className="dropdown-arrow">▼</span>
          </h3>
          <ul>
            <li><a href="#">About Us</a></li>
            <li><a href="#">FAQs</a></li>
            <li><a onClick={()=>navigate("/partner")}>Our Partners</a></li>
            <li><a href="#">Work With Us</a></li>
            <li><a href="#">Contact Us</a></li>
          </ul>
        </div>

        {/* Col 2 */}
        <div className={`footer-col ${openSection === 'shop' ? 'is-open' : ''}`}>
          <h3 onClick={() => toggleSection('shop')}>
            Shop
            <span className="dropdown-arrow">▼</span>
          </h3>
          <ul>
            <li><a href="#">Recently Viewed</a></li>
            <li><a href="#">Featured Products</a></li>
            <li><a href="#">Top 100 Appliances</a></li>
            <li><a href="#">Laptops</a></li>
            <li><a href="#">Toys & Games</a></li>
          </ul>
        </div>

        {/* Col 3 */}
        <div className={`footer-col ${openSection === 'useful' ? 'is-open' : ''}`}>
          <h3 onClick={() => toggleSection('useful')}>
            Useful Links
            <span className="dropdown-arrow">▼</span>
          </h3>
          <ul>
            <li><a href="#">Track Order</a></li>
            <li><a href="#">Latest News</a></li>
            <li><a href="#">Purchase Theme</a></li>
          </ul>
        </div>

        {/* Col 4: Newsletter, Payments & GeM Certification */}
        <div className="footer-right-panel">
          <div className="newsletter-card">
            <h3>Subscribe Newsletter</h3>
            <p>Join our mailing list to receive any latest updates and promotions.</p>
          </div>

          <div className="trust-and-payments">
            {/* Safety Payments Row */}
            <div className="payments-section">
              <h4>🔒 Safety Payments</h4>
              <div className="payment-badges">
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" />
                <img src="https://www.bing.com/th/id/OIP.DcFUX7UWJFIX_wiNF7Ma4AHaEg?w=193&h=135&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2" alt="Visa" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" />
                <img src="https://www.bing.com/th/id/OIP.7-mXhacUkTi0u6OSgGLgkAHaDq?w=226&h=128&c=8&rs=1&qlt=90&o=6&urlcheck=1&dpr=1.3&pid=ImgAns&rm=2" alt="ApplePay" />
              </div>
            </div>

            {/* GeM Government Certification Badge */}
            <div className="gem-certification-section">
              <h4>🏛️ Government Authorised</h4>
              <div className="gem-badge-box">
                <img 
                  src="https://gem.gov.in/resources/images/gem-new-logo-v2.svg" 
                  alt="GeM Certified" 
                  className="gem-logo"
                  onError={(e) => { e.target.src="https://assets-netstorage.groww.in/mutual-funds/brands/govt_of_india.png" }}
                />
                <div className="gem-text">
                  <strong>GeM Certified Vendor</strong>
                  <p>Registered under Government e-Marketplace</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM ROW: Copyright */}
      <div className="footer-bottom-bar">
        <p>Based on <span>Roy Mediative</span> Platform 2026. All Rights Reserved.</p>
        <button className="scroll-to-top-btn" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>↑</button>
      </div>
    </footer>
  );
};

export default Footer;